import { NavLink, useLocation } from "react-router-dom";
import { Tooltip, TooltipContent, TooltipTrigger } from "@/components/ui/tooltip";
import { DuotoneIcon } from "@/components/ui/icon";
import { cn } from "@/lib/utils";

interface SidebarNavButtonProps {
  to: string;
  icon: string;
  label: string;
  collapsed: boolean;
}

export function SidebarNavButton({ to, icon, label, collapsed }: SidebarNavButtonProps) {
  const location = useLocation();

  const isNavActive = () => location.pathname === to || location.pathname.startsWith(`${to}/`);

  if (collapsed) {
    return (
      <Tooltip>
        <TooltipTrigger asChild>
          <NavLink
            to={to}
            style={{ display: "flex", width: "100%", height: "36px", alignItems: "center", justifyContent: "center" }}
            className={isNavActive() ? "text-foreground" : "text-muted-foreground hover:text-foreground"}
          >
            <span
              className={cn(
                "flex items-center justify-center rounded-lg transition-colors",
                isNavActive() ? "bg-muted text-foreground" : "hover:bg-accent"
              )}
              style={{ width: "32px", height: "32px" }}
            >
              <DuotoneIcon name={icon} size={18} />
            </span>
          </NavLink>
        </TooltipTrigger>
        <TooltipContent side="right" sideOffset={8}>
          {label}
        </TooltipContent>
      </Tooltip>
    );
  }

  return (
    <NavLink
      to={to}
      className={cn(
        "flex items-center gap-3 rounded-lg px-3 py-2 transition-colors",
        "font-mono text-[11px] uppercase tracking-widest",
        isNavActive()
          ? "bg-muted text-foreground"
          : "text-muted-foreground hover:bg-accent hover:text-foreground"
      )}
    >
      <DuotoneIcon name={icon} size={16} className="shrink-0" />
      {label}
    </NavLink>
  );
}
